import {getResource, postForm} from './BaseRequests'

export const getWindowShop = (success, fail) => {
	getResource("windows").then(success).catch(fail);
}

export const getSingleWindowItems = ({id}, success, fail) => {
	getResource("window_products", {id: id}).then(success).catch(fail);
}
